import { AbstractCommand } from 'src/models/command';

class DeleteTheEditorStandardFontCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_DeleteTheEditorStandardFontCommand';

	public constructor() {
		super();
		this.parameters = {};
	}
}

export { DeleteTheEditorStandardFontCommand };
